// custom-header.component.ts
import {Component} from '@angular/core';
import {IHeaderAngularComp} from 'ag-grid-angular';
import {IHeaderParams} from 'ag-grid-community';

@Component({
  selector: 'app-custom-header',
  template: `
    <div
      [title]="title"
      [class.selected-header]="params.context?.selectedHeader?.getColId() === params.column?.getColId()"
      (click)="selectColumn($event)"
      tabindex="1"
    >{{ params.displayName.trim() }}</div>
  `,
  styleUrl: 'custom-header.component.scss',
  standalone: true,
})
export class CustomHeaderComponent implements IHeaderAngularComp {
  params: IHeaderParams;
  title: string;

  agInit(params: IHeaderParams): void {
    this.params = params;
    const columnWidth: number = params?.column?.getActualWidth(); // Get the width of the column
    if (!columnWidth) {
      this.title = '';
    } else {
      const threshold: number = (columnWidth - 32) / 6;
      this.title = params.displayName?.length > threshold ? params.displayName : '';
    }
  }

  selectColumn(evt: MouseEvent): void {
    if (evt.ctrlKey) {
      this.params.context.onHeaderCtrlClick(this.params.column);
    } else {
      this.params.context.onHeaderClick(this.params.column);
    }
  }

  refresh(params: IHeaderParams): boolean {
    return false;
  }
}
